import request from '@/utils/request'

// 工单分类
export const worksheetCategoryPage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCategoryPage`, method: 'post', data })

export const worksheetCategoryCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCategoryCount`, method: 'post', data })

export const worksheetCategoryIns = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCategoryIns`, method: 'post', data })

export const worksheetCategoryUpd = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCategoryUpd`, method: 'post', data })

export const worksheetCategoryDel = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCategoryDel`, method: 'post', data })

export const worksheetCategoryDelBatch = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCategoryDelBatch`, method: 'post', data })

// 工单配置
export const worksheetAssignRulePage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAssignRulePage`, method: 'post', data })

export const worksheetAssignRuleCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAssignRuleCount`, method: 'post', data })

export const worksheetAssignRuleIns = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAssignRuleIns`, method: 'post', data })

export const worksheetAssignRuleUpd = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAssignRuleUpd`, method: 'post', data })

export const worksheetAssignRuleDel = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAssignRuleDel`, method: 'post', data })

export const worksheetAssignRuleDelBatch = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAssignRuleDelBatch`, method: 'post', data })

// 工单列表
export const worksheetDetail = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetDetail`, method: 'post', data })

export const worksheetCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetCount`, method: 'post', data })

export const worksheetPage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetPage`, method: 'post', data })

export const worksheetIns = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetIns`, method: 'post', data })

export const worksheetUpd = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetUpd`, method: 'post', data })

export const worksheetDel = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetDel`, method: 'post', data })

export const worksheetDelBatch = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetDelBatch`, method: 'post', data })

export const worksheetXLDown = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetXLDown`, method: 'post', data })

export const worksheetHandleRecordList = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetHandleRecordList`, method: 'post', data })

export const worksheetDoAssign = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetDoAssign`, method: 'post', data })

export const worksheetSubmit = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetSubmit`, method: 'post', data })

export const worksheetChargeUserList = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetChargeUserList`, method: 'post', data })

export const workSheetHandleRecordSubmit = (params = {}) => request.post('/api/estate/v1/worksheet/workSheetHandleRecordSubmit', params)

export const worksheetRebates = (params = {}) => request.post('/api/estate/v1/worksheet/worksheetRebates', params)

// 回访列表
export const worksheetReturnViewPage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetReturnViewPage`, method: 'post', data })

export const worksheetReturnViewCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetReturnViewCount`, method: 'post', data })

export const worksheetReturnViewIns = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetReturnViewIns`, method: 'post', data })

// 评价列表

export const worksheetAppraiseCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAppraiseCount`, method: 'post', data })

export const worksheetAppraisePage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAppraisePage`, method: 'post', data })

export const worksheetAppraiseDel = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAppraiseDel`, method: 'post', data })

export const worksheetAppraiseDelBatch = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAppraiseDelBatch`, method: 'post', data })

// 评价列表
export const worksheetOrderPage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetOrderPage`, method: 'post', data })

export const worksheetOrderCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetOrderCount`, method: 'post', data })

export const worksheetOrderDetail = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetOrderDetail`, method: 'post', data })

// 工单报表
// 项目工单统计
export const worksheetStaticByCommunity = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticByCommunity`, method: 'post', data })

//工单分类统计
export const worksheetStaticByCategoryPage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticByCategoryPage`, method: 'post', data })
export const worksheetStaticByCategoryCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticByCategoryCount`, method: 'post', data })

// 工单概述统计
export const worksheetStaticReport = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticReport`, method: 'post', data })

// 工单报表——结单统计概览
export const worksheetStaticStatements = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticStatements`, method: 'post', data })

// 工单报表——结单统计
export const worksheetStaticStatementsByStaff = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticStatementsByStaff`, method: 'post', data })

// 工单报表-工单时效统计
export const worksheetStaticLapseByCategoryCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticLapseByCategoryCount`, method: 'post', data })

export const worksheetStaticLapseByCategory = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticLapseByCategory`, method: 'post', data })

export const worksheetStaticLapseByCommunity = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticLapseByCommunity`, method: 'post', data })

export const worksheetStaticLapseReport = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetStaticLapseReport`, method: 'post', data })


// 工单地点
export const worksheetAddressPage = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressPage`, method: 'post', data })

export const worksheetAddressCount = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressCount`, method: 'post', data })

export const worksheetAddressIns = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressIns`, method: 'post', data })

export const worksheetAddressUpd = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressUpd`, method: 'post', data })

export const worksheetAddressDel = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressDel`, method: 'post', data })

 
export const worksheetAddressDelBatch = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressDel/Batch`, method: 'post', data })
